import React from "react";
import { Grid } from "@material-ui/core";
import ListExp from "./ListExp";
import MediaCard1 from "./Card1";
import MediaCard23 from "./Card23";
export default function ExCard() {
  return (
    <Grid container xs={12} spacing={4} >
      <Grid  container justify="center" alignItems="stretch" item xs={6}>
        <MediaCard1 imgURL={ListExp[0].imgURL} title={ListExp[0].title} />
      </Grid>
      <Grid item xs={6} style={{ paddingRight: "0" }} spacing={4}  container>
        <Grid item xs={6}>
          <MediaCard23 imgURL={ListExp[1].imgURL} title={ListExp[1].title} />
        </Grid>
        <Grid item xs={6}>
          <MediaCard23 imgURL={ListExp[2].imgURL} title={ListExp[2].title} />
        </Grid>
        <Grid item xs={12}>
          <MediaCard23 imgURL={ListExp[3].imgURL} title={ListExp[3].title} />
        </Grid>
      </Grid>
    </Grid>
  );
}
